export const EceFaculty = [
    {
        "designation" : "Professor",
        "Name" :"Prof. S. Narayana Reddy",
        "Phone":"(+91)-9848927815",
        "Email" :"snreddysvu@yahoo.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/404865"
    },
    {
        "designation" : "Professor",
        "Name" :"Prof. R.V.S. Satyanarayana",
        "Phone":"	(+91)-9246204470",
        "Email" :"v.s.ravinutala@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/615537"
    },
    {
        "designation" : "Professor",
        "Name" :"Prof. G. Srinivasulu",
        "Phone":"(+91)-9490182693",
        "Email" :"	gunapatieee@rediffmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/393477"
    },
    {
        "designation" : "Professor",
        "Name" :"Prof. S. Varadarajan",
        "Phone":"	(+91)-9949300990",
        "Email" :"varadasouri@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/332216"
    },

    {
        "designation" : "Professor",
        "Name" :"Prof. B. Anuradha",
        "Phone":"(+91)-9441028112",
        "Email" :"	anubhuma@yahoo.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/428731"
    },
     {
        "designation" : "Professor",
        "Name" :"Prof. T. Ramashri",
        "Phone":"(+91)-9346465050",
        "Email" :"	rama_jaypee@rediffmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/422448"
    },
    {
        "designation" : "Professor",
        "Name" :"Prof. G. Umamaheswara Reddy",
        "Phone":"(+91)-917013224147",
        "Email" :"umaskit@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/390933"
    },
    {
        "designation" : "Professor",
        "Name" :"Prof. T. Sreenivasulu Reddy (On Leave)",
        "Phone":"(+91)-9440415699",
        "Email" :"	mettu86@yahoo.co.in",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/425552"
    },
    {
        "designation" : "Professor",
        "Name" :"Dr. S. Swarnalatha",
        "Phone":"(+91)-9490981637",
        "Email" :"swarnasvu09@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/427828"
    },
    {
        "designation" : "Professor",
        "Name" :"	Dr. I. Kullayamma",
        "Phone":"(+91)-9440488810",
        "Email" :"ikusuma96@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/407133"
    },
    {
        "designation" : "Associate Professor",
        "Name" :"Dr. D. Gowri Shankar Reddy",
        "Phone":"(+91)-8686677877",
        "Email" :"gowri.durgam@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/591615"
    },
    {
        "designation" : "Academic Consultant",
        "Name" :"I. Prathibha",
        "Phone":"(+91)-9390639601",
        "Email" :"ilaprathibha@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/591262"
    },
    {
        "designation" : "Academic Consultant",
        "Name" :"Subramanyam Kundali",
        "Phone":"(+91)-9440935243",
        "Email" :"subramanyam.kundili@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/591489"
    },
    {
        "designation" : "Academic Consultant",
        "Name" :"Shaik Jameer",
        "Phone":"(+91)-9494698902",
        "Email" :"roshanjameer87@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/391253"
    },
    {
        "designation" : "Academic Consultant",
        "Name" :"Chiranjeevi Althi",
        "Phone":"(+91)-9885528825",
        "Email" :"purnimaalthi@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/591267"
    },
    {
        "designation" : "Academic Consultant",
        "Name" :"Anumolu lasmika",
        "Phone":"(+91)-9542781318",
        "Email" :"anumolu.Lasmika@gmailcom",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/591236"
    },
    {
        "designation" : "Academic Consultant",
        "Name" :"G. Shirisha",
        "Phone":"(+91)-8297153484",
        "Email" :"sirishaece73@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/428694"
    },
    {
        "designation" : "Academic Consultant",
        "Name" :"Machireddy Chandana Priya",
        "Phone":"(+91)-8374119020",
        "Email" :"chandana.priya52@gmail.com",
        "Details" :"https://vidwan.inflibnet.ac.in//profile/591235"
    },
    
    

]

// {
//     "designation" : "",
//     "Name" :"",
//     "Phone":"",
//     "Email" :"",
//     "Details" :"NA"
// },